<template>
  <fragment>
    <v-container fluid pa-0>
      <CButton
              v-if="input.length === 0 && !isShowMode"
              class="ma-3"
              outlined
              small
              fab
              color="accent"
              @click="() => onAddContent(input)"
      >
        <v-icon>add</v-icon>
      </CButton>
      <v-layout justify-center column fill-height>
        <template v-for="(content, index) in input">
          <v-layout :key="index" row fill-height>
            <v-flex shrink v-if="!isShowMode">
              <v-layout column fill-height>
                <v-flex grow :style="(index === input.length - 1) ? 'min-height: 60px;' : ''">
                </v-flex>
                <v-flex shrink>
                  <CButton
                    v-if="index === input.length - 1"
                    class="ma-3"
                    small
                    fab
                    color="accent"
                    @click="() => onAddContent(input)"
                  >
                    <v-icon>add</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex  shrink :style="(index === input.length - 1) ? 'margin-left: -41px' : 'margin-left:23px'">
              <v-layout row>
                <v-flex sm5>
                  <CRow>
                    <CCol class="py-0">
                      <TextField
                              v-model="input[index]['name']"
                              :mode="mode"
                              :index="'name' + index"
                              :name="'material_1_' + index"
                              label="材料名"
                              remarks=""
                              placeholder="パスタ, 塩"
                              :rules="'required'"
                              :withLabel="true"
                              width="100%"
                      />
                    </CCol>
                  </CRow>
                </v-flex>
                <v-flex sm4>
                  <CRow>
                    <CCol class="py-0">
                      <TextField
                              v-model="input[index]['amount']"
                              :mode="mode"
                              :index="'amount' + index"
                              :name="'material_2_' + index"
                              label="量"
                              remarks=""
                              placeholder="0入力すると空欄表示"
                              :rules="'required|decimal'"
                              :withLabel="true"
                      />
                    </CCol>
                  </CRow>
                </v-flex>
                <v-flex sm3>
                  <CRow>
                    <CCol class="py-0">
                      <TextField
                              v-model="input[index]['unit']"
                              :mode="mode"
                              :index="'unit' + index"
                              :name="'material_3_' + index"
                              label="単位"
                              remarks=""
                              placeholder="g, 少々, 大さじ...."
                              :rules="'required'"
                              :withLabel="true"
                      />
                    </CCol>
                  </CRow>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex shrink>
              <v-layout column fill-height>
                <v-flex grow>
                  <CButton
                          color="red"
                          class="ma-3"
                          small
                          fab
                          dark
                          @click="() => onDeleteContent(input, index)"
                  >
                    <v-icon>clear</v-icon>
                  </CButton>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import TextField from "./text";

export default {
  components: {
    TextField
  },
  props: {
    input: {
      type: Array,
      default: () => []
    },
    resourceName: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: "edit",
      validator: value => ["show", "create", "edit"].indexOf(value) !== -1
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    isShowMode() {
      return this.mode === "show";
    },
    isCreateMode() {
      return this.mode === "create";
    },
    isEditMode() {
      return this.mode === "edit";
    }
  },
  methods: {
    onAddContent(input) {
      let initEntity = {"name": "", "amount": 0, "unit": "" };

      if(JSON.stringify(input[input.length - 1]) !== JSON.stringify(initEntity))
      {
        input.push(initEntity);
      }
    },
    onDeleteContent(input, index) {
      input.splice(index, 1);
      if(input.length === 0) {
        this.onAddContent(input);
      }
    }
  },
  created(){
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
